function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionsHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "625px",
    height: "625px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 139.5,38.5 C 255.167,38.5 370.833,38.5 486.5,38.5C 486.5,48.5 486.5,58.5 486.5,68.5C 370.833,68.5 255.167,68.5 139.5,68.5C 139.5,58.5 139.5,48.5 139.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 82.5,127.5 C 235.5,127.5 388.5,127.5 541.5,127.5C 541.5,137.5 541.5,147.5 541.5,157.5C 388.5,157.5 235.5,157.5 82.5,157.5C 82.5,147.5 82.5,137.5 82.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 10.5,218.5 C 212.167,218.5 413.833,218.5 615.5,218.5C 615.5,337.5 615.5,456.5 615.5,575.5C 413.833,575.5 212.167,575.5 10.5,575.5C 10.5,456.5 10.5,337.5 10.5,218.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsHover);
export default __webpack_public_path__ + "static/media/subscriptions-hover.b5751e7bd62579049a6c12d2f9d30253.svg";
export { ForwardRef as ReactComponent };